import { environment } from '@/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { handleError } from '../tools/handle-error.tools';
import { catchError, map } from 'rxjs';
import { Actividad } from '@/app/models/interface/actividad.model';
import {
  PaginatorModel,
  HasPagination,
} from '@/app/models/interface/paginator.model';
import { CustomResponse } from '@/app/models/interface/response.model';

@Injectable({ providedIn: 'root' })
export class ActividadService {
  private readonly http = inject(HttpClient);
  private readonly url = environment.api + 'actividad/';

  create(data: Partial<Actividad>) {
    return this.http.post<CustomResponse<Actividad>>(this.url, data).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return {
          ...d,
          competencias:
            d.actividadCompetencia?.map((ac) => ac.competencia) || [],
        };
      }),
    );
  }

  findAll(params?: HttpParams) {
    return this.http
      .get<CustomResponse<PaginatorModel<Actividad[], HasPagination>>>(
        this.url,
        {
          params,
        },
      )
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => {
          const d = data.result;
          if (d && Array.isArray(d.data)) {
            return {
              ...d,
              data: d.data.map((d) => ({
                ...d,
                competencias:
                  d.actividadCompetencia?.map((c) => c.competencia) || [],
              })),
            };
          }
          return d;
        }),
      );
  }

  findOne(id: string) {
    const url = this.url + id;
    return this.http.get<CustomResponse<Actividad>>(url).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return {
          ...d,
          competencias:
            d.actividadCompetencia?.map((ac) => ac.competencia) || [],
        };
      }),
    );
  }

  update(tipo: Partial<Actividad>) {
    const url = this.url + tipo.id;
    return this.http.put<CustomResponse<Actividad>>(url, tipo).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return {
          ...d,
          competencias:
            d.actividadCompetencia?.map((ac) => ac.competencia) || [],
        };
      }),
    );
  }

  changeState(state: boolean, id: string) {
    const url = this.url + id;
    return this.http.patch<CustomResponse<Actividad>>(url, { state }).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return {
          ...d,
          competencias:
            d.actividadCompetencia?.map((ac) => ac.competencia) || [],
        };
      }),
    );
  }
}
